var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompanyOutline = function SvgCompanyOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    fill: "none",
    viewBox: "0 0 20 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1B216B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 2.74h-1c0-.93-.625-1.687-1.397-1.687H5.394c-.769 0-1.397.756-1.397 1.688h-1c0-1.482 1.075-2.688 2.397-2.688h9.21C15.924.053 17 1.26 17 2.741M11.481 16.39V13.02H8.5v3.371zM9.5 14.02h.981v1.98H9.5zM9.534 7h-1v1h1zM11.5 7h-1v1h1zM11.481 9h-1v1h1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17h-7V5h7zm-6-1h5V6h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.519 9h-1v1h1zM9.519 11h-1v1h1zM11.481 11h-1v1h1zM7.5 16.39V7.36l-5 1.25v7.78zm-4-7 3-.75v7.376h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.519 10h-1v1h1zM5.519 12h-1v1h1zM5.5 14.019h-1v1h1zM17.5 16.39V8.61l-5-1.25v9.03zm-4-7.75 3 .75v6.626h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.484 11h1v-1h-1zM14.484 13h1v-1h-1zM14.5 15.016h1v-1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.313 17H2.688A2.69 2.69 0 0 1 0 14.313V5.688A2.69 2.69 0 0 1 2.688 3h14.625A2.69 2.69 0 0 1 20 5.688v8.625A2.69 2.69 0 0 1 17.313 17M2.688 4C1.756 4 1 4.756 1 5.688v8.625C1 15.243 1.756 16 2.688 16h14.625c.93 0 1.687-.756 1.687-1.687V5.688C19 4.756 18.244 4 17.313 4z"
  }))));
};
export { SvgCompanyOutline as Icon };
export default __webpack_public_path__ + "static/media/ea80dfff3ef75853aec0cec36d7b53a2.svg";